import React from "react";
import AromResultCard from "../Arom-Result-Card";
import { UpperBodyAromScore } from "../../models/reports";

interface Props {
  score: UpperBodyAromScore;
}
const UpperBodyAromTest: React.FC<Props> = ({ score }) => {
  return (
    <>
      {Object.entries(score).map(([key, value]) => {
        if (key === "id") {
          return;
        }
        return (
          <AromResultCard
            assessmentName={`${key}`}
            left={(value as { left: any; right: any }).left}
            right={(value as { left: any; right: any }).right}
            imgPath={value.imgPath}
          />
        );
      })}
    </>
  );
};

export default UpperBodyAromTest;
